module.exports = __webpack_public_path__ + "static/media/Pretzel.949da018.JPG";